import {
  FileSignature, FileText, Landmark, Home, FileCheck2, Car,
  Handshake, Users, Baby, Globe2,
} from "lucide-react";
import { SERVICES } from "@/lib/business";

const ICONS = [FileSignature, FileText, Landmark, Home, FileCheck2, Car, Handshake, Users, Baby, Globe2];

export const Services = () => (
  <section id="services" data-testid="services-grid" className="section-pad bg-surface">
    <div className="container-tn">
      <div className="max-w-3xl">
        <span className="eyebrow">What I Notarize</span>
        <span className="gold-rule" />
        <h2 className="font-serif text-navy uppercase text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          Everyday documents,<br />handled with care.
        </h2>
        <p className="mt-5 text-mutedink text-base sm:text-lg leading-relaxed">
          From a single signature to a full loan package — here are the notarizations I handle most often.
        </p>
      </div>

      <div className="mt-12 lg:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className="card-tn group"
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 flex items-center justify-center h-12 w-12 rounded-md bg-navy/[0.04] border border-gold-soft/40 group-hover:border-gold transition-colors">
                  <Icon className="w-6 h-6 text-gold" strokeWidth={1.75} />
                </div>
                <div className="min-w-0">
                  <h3 className="font-serif text-navy uppercase text-base sm:text-lg font-bold tracking-[0.06em]">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-mutedink leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <p className="mt-10 text-center text-mutedink text-base">
        Need something not listed?{" "}
        <a href="#contact" className="text-navy font-semibold underline decoration-gold decoration-2 underline-offset-4 hover:text-gold transition-colors">
          Call and I&apos;ll let you know if I can help.
        </a>
      </p>
    </div>
  </section>
);
